import React, {
    useState, useEffect

} from "react";
import ConferenceEventForm from "./ConferenceEventForm/ConferenceEventForm.jsx";
import ConferenceLogs from "./ConferenceLogs/ConferenceLogs.jsx";
import GeustConferenceManagment from "./GeustConferenceManagment/GeustConferenceManagment.jsx";
import { useTranslation } from "react-i18next";

import "./ConferenceEvent.css";

export default function ConferenceEvent({ onClose }) {
    const [activeTab, setActiveTab] = useState("edit");

    function useMobile() {
        const [isMobile, setIsMobile] = useState(window.innerWidth < 550);

        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth < 550);
            };

            window.addEventListener('resize', handleResize);

            // Nettoyage
            return () => window.removeEventListener('resize', handleResize);
        }, []);

        return isMobile;
    }
    const isMobile = useMobile();

    const { t } = useTranslation();

    return (
        <div className="conference-container">
            <div className="conference-tabs">
                <div className={`conference-tab ${activeTab === "edit" ? "active" : ""}`} onClick={() => setActiveTab("edit")}>
                    <span class="material-symbols-outlined">
                        edit
                    </span>
                    {t(isMobile ? 'edit-conference-mobile' : 'edit-conference')}
                </div>
                <div className={`conference-tab ${activeTab === "gestion" ? "active" : ""}`} onClick={() => setActiveTab("gestion")}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M2.5 2.5V15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H17.5" stroke="#A5ADBA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M15 14.1667V7.5" stroke="#A5ADBA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.8335 14.167V4.16699" stroke="#A5ADBA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M6.6665 14.167V11.667" stroke="#A5ADBA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    {t(isMobile ? 'mgt-conference-mobile' : 'mgt-conference')}
                </div>
                <div className={`conference-tab ${activeTab === "logs" ? "active" : ""}`} onClick={() => setActiveTab("logs")}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M12.5002 10H8.3335" stroke="#A5ADBA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12.5002 6.66699H8.3335" stroke="#A5ADBA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M15.8335 14.1667V4.16667C15.8335 3.72464 15.6579 3.30072 15.3453 2.98816C15.0328 2.67559 14.6089 2.5 14.1668 2.5H3.3335" stroke="#A5ADBA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M6.6665 17.5H16.6665C17.1085 17.5 17.5325 17.3244 17.845 17.0118C18.1576 16.6993 18.3332 16.2754 18.3332 15.8333V15C18.3332 14.779 18.2454 14.567 18.0891 14.4107C17.9328 14.2545 17.7209 14.1667 17.4998 14.1667H9.1665C8.94549 14.1667 8.73353 14.2545 8.57725 14.4107C8.42097 14.567 8.33317 14.779 8.33317 15V15.8333C8.33317 16.2754 8.15758 16.6993 7.84501 17.0118C7.53245 17.3244 7.10853 17.5 6.6665 17.5ZM6.6665 17.5C6.22448 17.5 5.80055 17.3244 5.48799 17.0118C5.17543 16.6993 4.99984 16.2754 4.99984 15.8333V4.16667C4.99984 3.72464 4.82424 3.30072 4.51168 2.98816C4.19912 2.67559 3.7752 2.5 3.33317 2.5C2.89114 2.5 2.46722 2.67559 2.15466 2.98816C1.8421 3.30072 1.6665 3.72464 1.6665 4.16667V5.83333C1.6665 6.05435 1.7543 6.26631 1.91058 6.42259C2.06686 6.57887 2.27882 6.66667 2.49984 6.66667H4.99984" stroke="#A5ADBA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    {t(isMobile ? 'conference-log-mobile' : 'conference-log')}
                </div>
            </div>

            <div className="conference-content">
                {activeTab === "edit" && <ConferenceEventForm onClose={onClose} />}
                {activeTab === "gestion" && <GeustConferenceManagment />}
                {activeTab === "logs" && <ConferenceLogs />}
            </div>
        </div>
    );
}